import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { Router } from "next/router";
import NProgress from "nprogress";
import React from "react";
var PageLevelProgressBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(PageLevelProgressBar, _Component);
    var _super = _create_super(PageLevelProgressBar);
    function PageLevelProgressBar() {
        _class_call_check(this, PageLevelProgressBar);
        return _super.apply(this, arguments);
    }
    _create_class(PageLevelProgressBar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                Router.events.on("routeChangeStart", function() {
                    return NProgress.start();
                });
                Router.events.on("routeChangeComplete", function() {
                    return NProgress.done();
                });
                Router.events.on("routeChangeError", function() {
                    return NProgress.done();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children;
            }
        }
    ]);
    return PageLevelProgressBar;
}(React.Component);
export default PageLevelProgressBar;
